var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "addActivity" },
    [
      _c("div", { staticClass: "left" }, [
        _c(
          "div",
          {
            staticStyle: {
              "border-bottom": "1px solid rgba(192, 195, 202, 1)",
              "margin-bottom": "0.23rem",
            },
          },
          [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "lineBox1" },
              [
                _vm._m(1),
                _c("el-input", {
                  staticStyle: { width: "2.5rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "请输入活动ID " },
                  model: {
                    value: _vm.input,
                    callback: function ($$v) {
                      _vm.input = $$v
                    },
                    expression: "input",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "lineBox1" },
              [
                _vm._m(2),
                _c("el-input", {
                  staticStyle: { width: "2.5rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "请输入活动名称" },
                  model: {
                    value: _vm.input,
                    callback: function ($$v) {
                      _vm.input = $$v
                    },
                    expression: "input",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "lineBox1" },
              [
                _vm._m(3),
                _c("el-input", {
                  staticStyle: { width: "2.5rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "请输入活动发起方 " },
                  model: {
                    value: _vm.input,
                    callback: function ($$v) {
                      _vm.input = $$v
                    },
                    expression: "input",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "lineBox1",
                staticStyle: { "margin-bottom": "0.4rem" },
              },
              [
                _vm._m(4),
                _c("el-date-picker", {
                  staticStyle: { "margin-right": "0.1rem" },
                  attrs: {
                    size: "small",
                    type: "daterange",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                  },
                  model: {
                    value: _vm.input,
                    callback: function ($$v) {
                      _vm.input = $$v
                    },
                    expression: "input",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "lineBox1",
                staticStyle: { "align-items": "flex-start" },
              },
              [
                _vm._m(5),
                _c("div", [
                  _c(
                    "div",
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "1" },
                          model: {
                            value: _vm.radio,
                            callback: function ($$v) {
                              _vm.radio = $$v
                            },
                            expression: "radio",
                          },
                        },
                        [_vm._v("C端")]
                      ),
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.checkList,
                            callback: function ($$v) {
                              _vm.checkList = $$v
                            },
                            expression: "checkList",
                          },
                        },
                        [
                          _c("el-checkbox", { attrs: { label: "小程序" } }),
                          _c("el-checkbox", { attrs: { label: "App" } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "2" },
                          model: {
                            value: _vm.radio,
                            callback: function ($$v) {
                              _vm.radio = $$v
                            },
                            expression: "radio",
                          },
                        },
                        [_vm._v("B端")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c("el-card", { staticClass: "box-card" }, [
              _c(
                "div",
                { staticStyle: { "margin-bottom": "0.2rem" } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "1" },
                      model: {
                        value: _vm.radio1,
                        callback: function ($$v) {
                          _vm.radio1 = $$v
                        },
                        expression: "radio1",
                      },
                    },
                    [_vm._v("所有B端渠道用户（指定用户总数：0）")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-bottom": "0.2rem" } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "2" },
                      model: {
                        value: _vm.radio1,
                        callback: function ($$v) {
                          _vm.radio1 = $$v
                        },
                        expression: "radio1",
                      },
                    },
                    [_vm._v("部分B端渠道用户（指定用户总数：10）")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "lineBox2" },
                [
                  _c("p", [_vm._v("按客户类型")]),
                  _c("div", { staticClass: "line" }),
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.checkList1,
                        callback: function ($$v) {
                          _vm.checkList1 = $$v
                        },
                        expression: "checkList1",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "抢单达人" } }),
                      _c("el-checkbox", { attrs: { label: "方案达人" } }),
                      _c("el-checkbox", { attrs: { label: "订单达人" } }),
                      _c("el-checkbox", { attrs: { label: "拓客达人" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "lineBox2",
                  staticStyle: { "align-items": "flex-start" },
                },
                [
                  _c("p", [_vm._v("按客户地域")]),
                  _c("div", { staticClass: "line" }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                      },
                    },
                    _vm._l(2, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "margin-bottom": "0.15rem",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "margin-right": "0.2rem" } },
                            [
                              _c("cityAutocomplete", {
                                attrs: { searchType: 2 },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { "margin-right": "0.2rem" } },
                            [_c("cityAutocomplete")],
                            1
                          ),
                          index == 0
                            ? _c("i", {
                                staticClass: "el-icon-plus",
                                staticStyle: {
                                  "font-size": "0.25rem",
                                  cursor: "pointer",
                                },
                              })
                            : _c("i", {
                                staticClass: "el-icon-minus",
                                staticStyle: {
                                  "font-size": "0.25rem",
                                  cursor: "pointer",
                                },
                              }),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "lineBox2" },
                [
                  _c("p", [_vm._v("按用户沉寂时间指定")]),
                  _c("div", { staticClass: "line" }),
                  _c("span", { staticStyle: { "margin-right": "0.2rem" } }, [
                    _vm._v("设定"),
                  ]),
                  _c("el-input", {
                    staticStyle: { width: "2rem", "margin-right": "0.1rem" },
                    attrs: { size: "small", placeholder: "数字" },
                    model: {
                      value: _vm.input,
                      callback: function ($$v) {
                        _vm.input = $$v
                      },
                      expression: "input",
                    },
                  }),
                  _c("span", [_vm._v("天内未登录")]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "lineBox2" },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "2" },
                      model: {
                        value: _vm.radio1,
                        callback: function ($$v) {
                          _vm.radio1 = $$v
                        },
                        expression: "radio1",
                      },
                    },
                    [_vm._v("指定B端渠道用户")]
                  ),
                  _c("div", { staticClass: "line" }),
                  _c("el-input", {
                    staticStyle: { width: "2rem", "margin-right": "0.1rem" },
                    attrs: { size: "small", placeholder: "请选择用户" },
                    model: {
                      value: _vm.input,
                      callback: function ($$v) {
                        _vm.input = $$v
                      },
                      expression: "input",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "lineBox1",
                staticStyle: {
                  "flex-direction": "column",
                  "align-items": "flex-start",
                  "margin-bottom": "0.4rem",
                },
              },
              [
                _vm._m(6),
                _c("img", {
                  attrs: { src: require("@/assets/png/liucheng.png"), alt: "" },
                }),
              ]
            ),
            _vm._m(7),
            _c("div", { staticClass: "lineBox3" }, [
              _vm._m(8),
              _c(
                "div",
                [
                  _c(
                    "p",
                    {
                      staticStyle: { color: "red", "margin-bottom": "0.1rem" },
                    },
                    [
                      _vm._v(
                        "1.主券的优患力度高于子券，更利于活动裂变传播 2.裂变优患券为普通优惠券"
                      ),
                    ]
                  ),
                  _c("el-card", { staticClass: "box-card1" }, [
                    _c(
                      "div",
                      { staticClass: "lineBox4" },
                      [
                        _c("p", [_vm._v("订单满:")]),
                        _c("el-input-number", {
                          staticStyle: { margin: "0 0.1rem" },
                          attrs: { size: "small" },
                        }),
                        _c("p", [_vm._v("元")]),
                        _vm._v("， 减"),
                        _c("el-input-number", {
                          staticStyle: { margin: "0 0.1rem" },
                          attrs: { size: "small" },
                        }),
                        _vm._v("元 "),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "lineBox4" },
                      [
                        _c("p", [_vm._v("有效期:领取后")]),
                        _c("el-input-number", {
                          staticStyle: { margin: "0 0.1rem" },
                          attrs: { size: "small" },
                        }),
                        _c("p", { staticStyle: { "margin-right": "0.1rem" } }, [
                          _vm._v("日内有效，逾期失效"),
                        ]),
                        _c("i", {
                          staticClass: "el-icon-sort",
                          staticStyle: {
                            transform: "rotate(-90deg)",
                            color: "#65A1F8",
                            cursor: "pointer",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "lineBox4" },
                      [
                        _c("p", [_vm._v("发放数量:")]),
                        _c("el-input-number", {
                          staticStyle: { margin: "0 0.1rem" },
                          attrs: { size: "small" },
                        }),
                        _c("p", { staticStyle: { "margin-right": "0.1rem" } }, [
                          _vm._v("人"),
                        ]),
                        _c("p", { staticStyle: { color: "#DED8D5" } }, [
                          _vm._v("建议数量尽可能多"),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "lineBox4",
                        staticStyle: { "margin-bottom": "0" },
                      },
                      [
                        _c("p", [_vm._v("获得条件: 领券好友数达")]),
                        _c("el-input", {
                          staticStyle: { margin: "0 0.1rem", width: "0.8rem" },
                          attrs: { type: "number", size: "small" },
                          model: {
                            value: _vm.input,
                            callback: function ($$v) {
                              _vm.input = $$v
                            },
                            expression: "input",
                          },
                        }),
                        _c("p", [_vm._v("人")]),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "lineBox3",
                staticStyle: { "margin-bottom": "0.2rem" },
              },
              [
                _vm._m(9),
                _c(
                  "div",
                  [
                    _c("el-card", { staticClass: "box-card1" }, [
                      _c(
                        "div",
                        { staticClass: "lineBox4" },
                        [
                          _c("p", [_vm._v("订单满:")]),
                          _c("el-input-number", {
                            staticStyle: { margin: "0 0.1rem" },
                            attrs: { size: "small" },
                          }),
                          _c("p", [_vm._v("元")]),
                          _vm._v("， 减"),
                          _c("el-input-number", {
                            staticStyle: { margin: "0 0.1rem" },
                            attrs: { size: "small" },
                          }),
                          _vm._v("元 "),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "lineBox4" },
                        [
                          _c("p", [_vm._v("有效期:领取后")]),
                          _c("el-input-number", {
                            staticStyle: { margin: "0 0.1rem" },
                            attrs: { size: "small" },
                          }),
                          _c(
                            "p",
                            { staticStyle: { "margin-right": "0.1rem" } },
                            [_vm._v("日内有效，逾期失效")]
                          ),
                          _c("i", {
                            staticClass: "el-icon-sort",
                            staticStyle: {
                              transform: "rotate(-90deg)",
                              color: "#65A1F8",
                              cursor: "pointer",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "lineBox4" },
                        [
                          _c("p", [_vm._v("发放数量:")]),
                          _c("el-input-number", {
                            staticStyle: { margin: "0 0.1rem" },
                            attrs: { size: "small" },
                          }),
                          _c(
                            "p",
                            { staticStyle: { "margin-right": "0.1rem" } },
                            [_vm._v("人")]
                          ),
                          _c("p", { staticStyle: { color: "#DED8D5" } }, [
                            _vm._v("建议数量尽可能多"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "lineBox4",
                          staticStyle: { "margin-bottom": "0" },
                        },
                        [_vm._v(" 发放数量：300 ")]
                      ),
                    ]),
                  ],
                  1
                ),
              ]
            ),
            _c("div", { staticClass: "lineBox3" }, [
              _c("p", { staticStyle: { width: "1rem" } }),
              _c(
                "div",
                [
                  _c(
                    "el-card",
                    {
                      staticClass: "box-card1",
                      staticStyle: {
                        "background-color": "#F8F8F8",
                        "justify-content": "flex-start",
                      },
                    },
                    [
                      _c("p", [_vm._v("预计总费用: 2000元")]),
                      _c("p", [_vm._v("主券:500元")]),
                      _c("p", [_vm._v("子券:1500元")]),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "lineBox1" },
              [
                _vm._m(10),
                _c("el-input", {
                  staticStyle: { width: "2.5rem", "margin-right": "0.1rem" },
                  attrs: { size: "small" },
                  model: {
                    value: _vm.input,
                    callback: function ($$v) {
                      _vm.input = $$v
                    },
                    expression: "input",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "lineBox1" },
              [
                _c("p", { staticClass: "p1" }, [_vm._v("使用范围")]),
                _c(
                  "el-radio",
                  {
                    attrs: { label: "1" },
                    on: { change: _vm.selectGoodsChange },
                    model: {
                      value: _vm.radio,
                      callback: function ($$v) {
                        _vm.radio = $$v
                      },
                      expression: "radio",
                    },
                  },
                  [_vm._v("本公司的所有商品")]
                ),
                _c(
                  "el-radio",
                  {
                    attrs: { label: "2" },
                    on: { change: _vm.selectGoodsChange },
                    model: {
                      value: _vm.radio,
                      callback: function ($$v) {
                        _vm.radio = $$v
                      },
                      expression: "radio",
                    },
                  },
                  [
                    _vm._v("指定商品 已选线路 "),
                    _c("span", { staticStyle: { color: "#DB4E1A" } }, [
                      _vm._v("3"),
                    ]),
                    _vm._v("条 "),
                    _c("el-button", { attrs: { size: "mini" } }, [
                      _vm._v("选择方案"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._m(11),
            _vm._m(12),
            _c(
              "div",
              {
                staticClass: "lineBox1",
                staticStyle: {
                  "align-items": "flex-start",
                  "margin-bottom": "0.5rem",
                },
              },
              [
                _c("p", { staticClass: "p1" }, [
                  _vm._v("选择平台活动推广方式"),
                ]),
                _c(
                  "el-checkbox-group",
                  {
                    staticStyle: { margin: "0 !important" },
                    model: {
                      value: _vm.checkList,
                      callback: function ($$v) {
                        _vm.checkList = $$v
                      },
                      expression: "checkList",
                    },
                  },
                  [
                    _c("el-checkbox", [
                      _c(
                        "p",
                        {
                          staticStyle: {
                            color: "#000",
                            "margin-bottom": "0.16rem",
                          },
                        },
                        [
                          _vm._v("手机短信通知 （ "),
                          _c("span", { staticStyle: { color: "#8D959F" } }, [
                            _vm._v("收费标准0.06元/条 您目前短信储值为 0 "),
                            _c("span", { staticStyle: { color: "#DB4E1A" } }, [
                              _vm._v("充值"),
                            ]),
                            _vm._v(" ）"),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        { staticStyle: { color: "#6B7785", display: "flex" } },
                        [
                          _c(
                            "span",
                            { staticStyle: { "margin-right": "0.1rem" } },
                            [_vm._v(" 短信编辑：")]
                          ),
                          _c("el-input", {
                            staticStyle: { width: "5rem" },
                            attrs: {
                              type: "textarea",
                              placeholder:
                                "XXX（这里带入用户企业名称）给您送现金券啦！赶紧点击去看看吧~  http://a.app.qq.com/oupons.yyb",
                              "show-word-limit": "",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("el-checkbox", [
                      _c(
                        "p",
                        {
                          staticStyle: {
                            color: "#000",
                            "margin-bottom": "0.16rem",
                          },
                        },
                        [_vm._v("系统Push消息")]
                      ),
                      _c(
                        "div",
                        { staticStyle: { color: "#6B7785", display: "flex" } },
                        [
                          _c(
                            "span",
                            { staticStyle: { "margin-right": "0.1rem" } },
                            [_vm._v(" 消息编辑：")]
                          ),
                          _c("el-input", {
                            staticStyle: { width: "5rem" },
                            attrs: {
                              type: "textarea",
                              placeholder:
                                "地接360给您送现金券啦！同业下单小能手下单专享，赶紧点击去看看吧~[点击查看]http://a.app.qq.com/oupons.yybhttp://a.app.qq.com/oupons.yyb",
                              "show-word-limit": "",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "justify-content": "center",
                  "margin-bottom": "0.42rem",
                },
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "1rem" },
                    attrs: { type: "primary" },
                  },
                  [_vm._v("已提交")]
                ),
                _c("el-button", { staticStyle: { width: "1rem" } }, [
                  _vm._v("取消"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "lineBox5" },
          [
            _vm._m(13),
            _c("el-card", { staticClass: "box-card3" }, [
              _c(
                "div",
                { staticClass: "div2" },
                [
                  _c("p", { staticClass: "p2" }, [_vm._v("社交网络邀请")]),
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "5rem" },
                      attrs: { placeholder: "请输入内容" },
                    },
                    [
                      _c(
                        "template",
                        { slot: "append" },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                "background-color": "#398187",
                                color: "#fff",
                              },
                            },
                            [_vm._v("复制链接")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                "background-color": "#CD3734",
                                color: "#fff",
                              },
                              attrs: { icon: "el-icon-search" },
                            },
                            [_vm._v("微博")]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "div2",
                  staticStyle: {
                    "align-items": "flex-start",
                    "margin-bottom": "0.3rem",
                  },
                },
                [
                  _c("p", { staticClass: "p2" }, [_vm._v("微信邀请")]),
                  _c("div", { staticClass: "div3" }, [
                    _c("div", { staticClass: "div3T" }, [
                      _c("span", [_vm._v("第一步：微信扫描二维码")]),
                      _c("span", [_vm._v("第二步：点击...分享页面")]),
                    ]),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/png/QRcode.png"),
                        alt: "",
                      },
                    }),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "div2" },
                [
                  _c("p", { staticClass: "p2" }, [_vm._v("邮箱邀请")]),
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "5rem" },
                      attrs: { placeholder: "请输入电子邮箱" },
                    },
                    [
                      _c(
                        "template",
                        { slot: "append" },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                "background-color": "#CD3634",
                                color: "#fff",
                              },
                            },
                            [_vm._v("发送邀请")]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "rightTop" }, [
          _vm._m(14),
          _c(
            "div",
            { staticClass: "div2" },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: "1" },
                  model: {
                    value: _vm.radio3,
                    callback: function ($$v) {
                      _vm.radio3 = $$v
                    },
                    expression: "radio3",
                  },
                },
                [_vm._v("WWW.DIJIE360.COM")]
              ),
              _c(
                "el-radio",
                {
                  attrs: { label: "2" },
                  model: {
                    value: _vm.radio3,
                    callback: function ($$v) {
                      _vm.radio3 = $$v
                    },
                    expression: "radio3",
                  },
                },
                [_vm._v("小程序")]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticStyle: { display: "flex", "justify-content": "center" } },
          [
            _c("img", {
              staticClass: "imgs",
              attrs: { src: _vm.viewImgs[_vm.radio3] },
            }),
          ]
        ),
      ]),
      _c("AddActivityGoods", { ref: "AddActivityGoods" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _vm._v(" 创建活动"),
      _c("span", [_vm._v("-旅游基金限时领！")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "p1" }, [
      _vm._v("活动ID"),
      _c("span", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "p1" }, [
      _vm._v("活动名称"),
      _c("span", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "p1" }, [
      _vm._v("活动发起方"),
      _c("span", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "p1" }, [
      _vm._v("活动时间段"),
      _c("span", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "p1" }, [
      _vm._v("活动平台"),
      _c("span", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "p1", staticStyle: { width: "1.7rem" } }, [
      _vm._v("活动规则介绍（举例）"),
      _c("span", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "lineBox1" }, [
      _c(
        "p",
        {
          staticClass: "p1",
          staticStyle: { width: "1.7rem", "margin-bottom": "0.2rem" },
        },
        [_vm._v("优惠卷设置"), _c("span", [_vm._v("*")])]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticStyle: { width: "1rem" } }, [
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
      _vm._v("主劵： "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticStyle: { width: "1rem" } }, [
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
      _vm._v("子劵： "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "p1" }, [
      _vm._v("预警邮箱"),
      _c("span", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "lineBox1" }, [
      _c("p", { staticClass: "p1" }, [_vm._v("展示效果")]),
      _vm._v(
        " 小程序及www.dijie360.com 的企业介绍页面 (展现形式参照右侧样例) "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "lineBox1" }, [
      _c("p", { staticClass: "p1" }, [_vm._v("发放方式")]),
      _vm._v(" 客户行为触发 (点击或扫二维码) "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "p1" }, [
      _vm._v("活动提交后您还可以自己以下方方式推广，效果最佳哦~ "),
      _c("span", [_vm._v("(推荐!!!)")]),
      _vm._v(" 提交前下方信息仅为样例参考 非本次活动！"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "div1" }, [
      _c("span", [_vm._v("效果样例")]),
      _c("p", [_vm._v("可点击图片查看放大效果")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }